import slugify from "slugify";

export function websiteBuilderSlugify(value: string): string {
  return slugify(value, {
    replacement: "-",
    remove: undefined,
    lower: true,
    strict: true,
    locale: undefined,
    trim: true,
  });
}